
import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Splash from "../pages/splash/page";
import Language from "../pages/language/page";
import Auth from "../pages/auth/page";
import Main from "../pages/main/page";
import Passengers from "../pages/passengers/page";
import PassengerProfile from "../pages/passenger-profile/page";
import Notifications from "../pages/notifications/page";
import Profile from "../pages/profile/page";
import Settings from "../pages/settings/page";
import Chats from "../pages/chats/page";
import History from "../pages/history/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Splash />,
  },
  {
    path: "/language",
    element: <Language />,
  },
  {
    path: "/auth",
    element: <Auth />,
  },
  {
    path: "/main",
    element: <Main />,
  },
  {
    path: "/passengers",
    element: <Passengers />,
  },
  {
    path: "/passenger-profile/:id",
    element: <PassengerProfile />,
  },
  {
    path: "/notifications",
    element: <Notifications />,
  },
  {
    path: "/profile",
    element: <Profile />,
  },
  {
    path: "/settings",
    element: <Settings />,
  },
  {
    path: "/chats",
    element: <Chats />,
  },
  {
    path: "/history",
    element: <History />,
  },
  {
    path: "/home",
    element: <Home />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;